import {Box, Skeleton} from "@mui/material";
import {Card, CardBody} from "react-bootstrap";

const ProfileImageSuspense = () => {
    return (
       <Card>
           <CardBody>
               <div className="d-100 d-flex flex-column justify-content-center align-items-center">
                   <Skeleton variant="circular" width={80} height={80}/>

                   <Skeleton variant="text" width={100} height={30} sx={{mt: 2}}/>

                   <Skeleton variant="text" width={150} height={20}/>

                   <div className='d-flex gap-3 mt-2'>
                       <Skeleton variant="rectangular" width={120} height={36}/>
                   </div>
               </div>
           </CardBody>
        </Card>
    );
};

export default ProfileImageSuspense;
